export const getAuthorIdFromSearchValue = (value?: string | null) =>
    value && value.includes('.') ? value.split('.')[1] : value;
